export const LOGIN_DATA_ACTION = 'LOGIN_DATA_ACTION';
export const RESET_DATA_ACTION = 'RESET_DATA_ACTION';
export const LOGIN_DATA_ERROR = 'LOGIN_DATA_ERROR';
export const LOGINAS_SUCCESS = 'LOGINAS_SUCCESS';
export const LOGINAS_FAILURE = 'LOGINAS_FAILURE';
export const RESET_AS_HOME = 'RESET_AS_HOME';